// extracted by mini-css-extract-plugin
export default {"header":"mI","discountBanner":"nI","logo":"oI","maincontainer":"pI","videocontainer":"qI","videowelcome":"rI","videowrapper":"sI","videosale":"tI","loadingcontainer":"uI","footer":"vI","footerbutton":"wI","video":"xI","logoname":"yI"};
    if(module.hot) {
      // 1711394578682
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  